import React, { memo } from 'react';
// import { Switch, Route, Redirect } from 'react-router-dom';

// import ProjectsForm from './projectsForm';
import { Routes } from '@components';

// import '@style/modules/project/project.scss';
import '../../styles/modules/project/project.scss';

function Project(props) {
  const { match, routes } = props;
  return (
    <div className="project">
      <div className="project-body-wrapper">
        <Routes routeData={routes} rootPath={match.path} />
      </div>
    </div>
  );
}

export default memo(Project);
